import { Injectable } from "@angular/core";
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { AppAbility } from "../../util/service/auth.service";
import { Observable } from "rxjs";
import { EntityTyp } from "../../util/enums/entity-typ.enum";
import { BaseFormGroupService } from "../../util/components/modal/base-form-group.service";
import { ClientDto } from "app/api/models";
import { ClientService } from "app/api/services";
import { CaslAction } from "app/server/enums/casl-action.enum";

@Injectable({
  providedIn: "root",
})
export class ClientFormGroupService extends BaseFormGroupService<ClientDto> {
  entitySingular = "Klient:in";

  constructor(
    private fb: FormBuilder,
    public override modal: NgbActiveModal,
    protected toastr: ToastrService,
    private clientService: ClientService,
    private ability: AppAbility
  ) {
    super(modal, toastr);
  }

  initFormGroup() {
    this.formGroup = this.fb.group({
      firstName: ["", [Validators.required]],
      lastName: ["", [Validators.required]],
      birthday: [null, [Validators.required]],
      entryDate: [null, [Validators.required]],
      email: ["", [Validators.email]],
      phone: [""],
      ssn: [null],
      ifa: [null],
      gz: [null],
      comment: [""],
      officeId: [null, Validators.required],
      housingId: [null],
      roomNr: [null],
      caregivers: [[]],
      status: [null],
      drugs: [""],
      allergies: [""],
      vaccines: [""],
      education: [""],
      contacts: [""],
      version: [0, [Validators.required]],
    });

    this.setPermissions();
  }

  get officeIdFormControl() {
    return this.formGroup.get("officeId") as FormControl<number>;
  }

  get officeId() {
    return this.officeIdFormControl.value;
  }

  get housingIdFormControl() {
    return this.formGroup.get("housingId") as FormControl<number>;
  }

  get housingId() {
    return this.housingIdFormControl.value;
  }

  get statusFormControl() {
    return this.formGroup.get("status") as FormControl<string>;
  }

  get caregiversFormControl() {
    return this.formGroup.get("caregivers") as FormControl<number[]>;
  }

  get caregivers() {
    return this.caregiversFormControl.value;
  }

  protected create(mergedEntity: ClientDto): Observable<ClientDto> {
    return this.clientService.clientControllerCreate({ body: mergedEntity });
  }

  protected update(mergedEntity: ClientDto): Observable<ClientDto> {
    return this.clientService.clientControllerUpdate({
      body: mergedEntity,
    });
  }

  protected reloadEntity(id: number): Observable<ClientDto> {
    return this.clientService.clientControllerFindOne({ id });
  }

  protected updateFormGroup(entity: ClientDto) {
    this.formGroup.patchValue(entity, { emitEvent: false });
    this.setPermissions();
  }

  private setPermissions() {
    if (this.ability.can(CaslAction.Update, EntityTyp.Client)) {
      return;
    }
    this.formGroup.disable({ emitEvent: false });
  }
}
